import { render, staticRenderFns } from "./attachmentPreview.vue?vue&type=template&id=59cb8132&scoped=true&"
import script from "./attachmentPreview.vue?vue&type=script&lang=js&"
export * from "./attachmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./attachmentPreview.vue?vue&type=style&index=0&id=59cb8132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cb8132",
  null
  
)

export default component.exports